import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Box } from "@mui/material";
import { MyNewsListItem, MyNewsLoadingComponent } from "my-news/components";
import { useMyNewsAdminList } from "my-news/hooks";
import { OcIconForState } from "oc/components";

interface MyNewsAdminListProps {
  isMobile: boolean;
}

export const MyNewsAdminList = ({ isMobile }: MyNewsAdminListProps) => {
  const [pageSize, setPageSize] = useState(4);

  const { data, loading, error, handleFetchMore } = useMyNewsAdminList();

  const list = data?.rows || [];

  const loadMoreData = () => {
    setPageSize(pageSize + 4);
    handleFetchMore(pageSize);
  };

  return (
    <Box display="flex" flexDirection="column">
      <InfiniteScroll
        dataLength={pageSize}
        next={loadMoreData}
        hasMore={data?.total > list?.length}
        scrollThreshold={0.95}
        loader={null}
      >
        <MyNewsLoadingComponent
          isMobile={isMobile}
          loading={loading && !error && list?.length === 0}
        />
        <OcIconForState
          data={list}
          loading={loading}
          isMobile={isMobile}
          error={!!error}
          module="MyNews"
        />
        {list?.map((item: any, index: number) => (
          <Box key={item._id}>
            <MyNewsListItem item={item} isAdminList={true} />
            <Box height="16px" />
            {item?.priority === "high" &&
              !item.read &&
              list[index + 1]?.priority === "normal" && (
                <Box
                  style={{
                    borderBottom: `1px solid #C6CACC`,
                    marginBottom: "16px",
                  }}
                />
              )}
          </Box>
        ))}
      </InfiniteScroll>
    </Box>
  );
};

export default MyNewsAdminList;
